export default function(eventData, courseData) {
  'ngInject';
  const vm = this;

  vm.$onInit = activate;

  function activate() {
    vm.event = eventData.data.event;
    vm.course = courseData.data.course;
  }
}



// WEBPACK FOOTER //
// ./src/app/controllers/admin/events/event/views/certificates/index.js